// import React, { useCallback, useEffect, useState } from "react";
// import { Button } from "antd";
// import { SearchBar } from "../../../../../components/Elements/Search/SearchBar";
// import { Tables } from "../../../../../components/Elements/Tables/Tables";
// import SortData from "../../../../../components/Elements/SortData.js/SortData";
// import { ReactComponent as EyeIcon } from "../../../../../assets/svgs/eye-icon.svg";
// import AddNewDynamicForm from "../DailogBoxes/AddNewDynamicForm";
// import ViewDynamicForm from "../../DynamicForm/ViewForm/ViewDynamicForm";
// import { getApi, postApi } from "../../../../../api/api_instance";
// import { API_URLS } from "../../../../../api/apiUrls";
// import { useNavigate } from "react-router-dom";

// const surveyHeader = [
//   { label: "Sr. No.", key: "serial" },
//   { label: "Project Name", key: "formName" },
//   { label: "Assigned On", key: "assignedOn" },
//   { label: "Action", key: "action" },
// ];

// const DynamicForm = ({
//   clientId,
//   projectId,
//   setOpenAssignedForm,
//   setAssignedFormtype,
// }) => {
//   const [viewForm, setViewForm] = useState(false);
//   const [sortBy, setSortBy] = useState(null);
//   const [sortOrder, setSortOrder] = useState(null);
//   const [openAddNew, setOpenAddNew] = useState(false);
//   const [selectedForms, setSelectedForms] = useState([]);
//   const [allData, setAllData] = useState([]); // for search
//   const [filteredData, setFilteredData] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [pagination, setPagination] = useState({
//     current: 1,
//     pageSize: 10,
//     total: 0,
//   });

//   const navigate = useNavigate();

//   const addForms = async ({ projectId, selectedForms }) => {
//     const data = {
//       custom_form: selectedForms,
//     };
//     try {
//       const response = await postApi({
//         apiUrl: API_URLS.ADD_NEW_DYNAMIC_FORM(projectId),
//         data,
//       });

//       if (response?.success) {
//         fetchTableData();
//       }
//     } catch (error) {
//       console.error("Error adding forms:", error);
//     }
//   };

//   const handleSort = (key, order) => {
//     const sortedData = SortData({ data: filteredData, key, order });
//     setFilteredData(sortedData);
//     setSortBy(key);
//     setSortOrder(order);
//   };
//   // const handlePageChange = (page, pageSize) => {
//   //   setPagination({
//   //     ...pagination,
//   //     current: page,
//   //     pageSize: pageSize,
//   //   });
//   // };

//   const fetchTableData = useCallback(async () => {
//     try {
//       const response = await getApi({
//         apiUrl: API_URLS.GET_CUSTOM_FORM_BY_PROJECTID(projectId),
//       });
//       if (response?.success) {
//         const data = response.data.map((item, index) => ({
//           key: item._id,
//           serial: index + 1,
//           formName: item.title,
//           assignedOn: "-",
//           action: (
//             <div className="flex gap-3">
//               <EyeIcon
//                 style={{ fontSize: "18px", cursor: "pointer" }}
//                 onClick={() => {
//                   navigate(`/organization/assigned-form/view/${item._id}`);
//                 }}
//               />
//             </div>
//           ),
//         }));
//         setAllData(data);
//         setFilteredData(data);
//         setPagination((prev) => ({
//           ...prev,
//           total: data.length,
//         }));
//       }
//     } catch (error) {
//       console.error("Error fetching standard survey forms:", error);
//     }
//   }, [clientId, projectId, navigate]);

//   useEffect(() => {
//     if (!openAddNew && selectedForms.length > 0) {
//       addForms({ projectId, selectedForms });
//     }
//   }, [selectedForms]);

//   useEffect(() => {
//     if (projectId) {
//       fetchTableData();
//     }
//   }, [projectId, fetchTableData]);

//   const handleSearch = (value) => {
//     setSearchTerm(value);
//     if (value.trim() === "") {
//       setFilteredData(allData);
//     } else {
//       const lower = value.toLowerCase();
//       const result = allData.filter(
//         (item) =>
//           item.formName.toLowerCase().includes(lower) ||
//           item.assignedOn.toLowerCase().includes(lower),
//       );
//       setFilteredData(result);
//     }
//   };

//   return (
//     <div style={{ border: "1px solid #3BA2B959", borderRadius: "10px",backgroundColor:"#fff" }}>
//       <div className="flex justify-between mx-8 mt-4 font-medium">
//         <div className="flex gap-16">
//           <p className="text-[#06513D] pt-2">DYNAMIC FORMS</p>
//           <div>
//             <SearchBar width="300px" onSearch={handleSearch} />
//           </div>
//         </div>
//         <div className="flex gap-10 mb-2">
//           <Button
//             type="primary"
//             style={{
//               background: "#06513D",
//               height: "50px",
//               width: "150px",
//               borderRadius: "10px",
//             }}
//             className="text-xs font-light"
//             onClick={() => {
//               setOpenAssignedForm(true);
//               setAssignedFormtype("dynamic");
//             }}
//           >
//             Assigned Form
//           </Button>
//           <Button
//             type="primary"
//             style={{
//               background: "#06513D",
//               height: "50px",
//               width: "150px",
//               borderRadius: "10px",
//             }}
//             className="text-xs font-light"
//             onClick={() => setOpenAddNew(true)}
//           >
//             Add New
//           </Button>
//         </div>
//       </div>

//       <div>
//         {filteredData.length === 0 ? (
//           <div>
//             <hr />
//             <div className="text-2xl text-center my-14">No Forms Available</div>
//           </div>
//         ) : (
//           <Tables
//             data={filteredData.slice(
//               (pagination.current - 1) * pagination.pageSize,
//               pagination.current * pagination.pageSize,
//             )}
//             headers={surveyHeader}
//             sortBy={sortBy}
//             sortOrder={sortOrder}
//             onSort={handleSort}
//             pagination={false} // Disable built-in pagination
//           />
//         )}
//       </div>
//       {/* Custom Pagination Footer */}
//       {/* <div className="flex flex-wrap items-center justify-between px-6 py-4 border-t border-gray-200 gap-4">

//         <div className="flex items-center text-sm text-gray-700 gap-2">
//           <span>Showing</span>
//           <select
//             className="border  rounded px-2 py-1"
//             style={{ borderColor: "#0087A3" }}
//             value={pagination.pageSize}
//             onChange={(e) => {
//               const newSize = Number(e.target.value);
//               setPagination((prev) => ({
//                 ...prev,
//                 current: 1,
//                 pageSize: newSize,
//               }));
//             }}
//           >
//             <option value={5}>5</option>
//             <option value={10}>10</option>
//             <option value={20}>20</option>
//           </select>
//         </div>

//         <div className="text-sm text-gray-600 flex-1 text-center">
//           Showing {(pagination.current - 1) * pagination.pageSize + 1} to{" "}
//           {Math.min(pagination.current * pagination.pageSize, pagination.total)}{" "}
//           of {pagination.total} records
//         </div>

//         <div className="flex gap-1 flex-wrap">
//           {Array.from({
//             length: Math.ceil(pagination.total / pagination.pageSize),
//           }).map((_, i) => {
//             const page = i + 1;
//             return (
//               <button
//                 key={page}
//                 onClick={() =>
//                   setPagination((prev) => ({
//                     ...prev,
//                     current: page,
//                   }))
//                 }
//                 className={`px-3 py-1 rounded ${
//                   page === pagination.current
//                     ? "bg-[#0087A3] text-white"
//                     : "bg-gray-200 text-gray-700"
//                 }`}
//               >
//                 {page}
//               </button>
//             );
//           })}
//         </div>
//       </div> */}

//       {openAddNew && (
//         <AddNewDynamicForm
//           onOpen={openAddNew}
//           onClose={() => setOpenAddNew(false)}
//           projectId={projectId}
//           selectedForms={selectedForms}
//           setSelectedForms={setSelectedForms}
//           addForms={addForms}
//         />
//       )}

//       {viewForm && (
//         <ViewDynamicForm
//           viewForm={viewForm}
//           onClose={() => setViewForm(false)}
//         />
//       )}
//     </div>
//   );
// };

// export default DynamicForm;

import React, { useCallback, useEffect, useState } from "react";
import { Button } from "antd";
import { SearchBar } from "../../../../../components/Elements/Search/SearchBar";
import { Tables } from "../../../../../components/Elements/Tables/Tables";
import SortData from "../../../../../components/Elements/SortData.js/SortData";
import { ReactComponent as EyeIcon } from "../../../../../assets/svgs/eye-icon.svg";
import AddNewDynamicForm from "../DailogBoxes/AddNewDynamicForm";
import ViewDynamicForm from "../../DynamicForm/ViewForm/ViewDynamicForm";
import { getApi, postApi } from "../../../../../api/api_instance";
import { API_URLS } from "../../../../../api/apiUrls";
import { useNavigate } from "react-router-dom";
import PopupCard from "../../../../Auth/PopupCard";
import { Heading3, Sparkles } from "lucide-react";

const surveyHeader = [
  { label: "Sr. No.", key: "serial" },
  { label: "Project Name", key: "formName" },
  { label: "Assigned On", key: "assignedOn" },
  { label: "Action", key: "action" },
];

const DynamicForm = ({
  clientId,
  projectId,
  setOpenAssignedForm,
  setAssignedFormtype,
}) => {
  const [viewForm, setViewForm] = useState(false);
  const [sortBy, setSortBy] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);
  const [openAddNew, setOpenAddNew] = useState(false);
  const [selectedForms, setSelectedForms] = useState([]);
  const [allData, setAllData] = useState([]); // for search
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [showPopup, setShowPopup] = useState(false);
  const [popupData, setPopupData] = useState({
    type: "success",
    title: "Success",
    message: "",
  });
  const navigate = useNavigate();

  const triggerPopup = (type, title, message, duration = 3000) => {
    setPopupData({ type, title, message });
    setShowPopup(true);
    setTimeout(() => setShowPopup(false), duration);
  };
  const addForms = async ({ projectId, selectedForms }) => {
    const data = {
      custom_form: selectedForms,
    };
    try {
      const response = await postApi({
        apiUrl: API_URLS.ADD_NEW_DYNAMIC_FORM(projectId),
        data,
      });

      if (response?.success) {
        triggerPopup("success", "Success", "Dynamic Form Add successfully!");
        fetchTableData();
      }
    } catch (error) {
      console.error("Error adding forms:", error);
    }
  };

  const handleSort = (key, order) => {
    const sortedData = SortData({ data: filteredData, key, order });
    setFilteredData(sortedData);
    setSortBy(key);
    setSortOrder(order);
  };

  // const fetchTableData = useCallback(async () => {
  //   try {
  //     const response = await getApi({
  //       apiUrl: API_URLS.GET_CUSTOM_FORM_BY_PROJECTID(projectId),
  //     });
  //     if (response?.success) {
  //       // const data = response.data.map((item, index) => ({
  //       //   key: item._id,
  //       //   serial: index + 1,
  //       //   formName: item.title,
  //       //   assignedOn: "-",
  //       //   action: (
  //       //     <div className="flex gap-2 sm:gap-3">
  //       //       <EyeIcon
  //       //         style={{ fontSize: "16px", cursor: "pointer" }}
  //       //         className="sm:text-lg"
  //       //         onClick={() => {
  //       //           navigate(`/organization/assigned-form/view/${item._id}`);
  //       //         }}
  //       //       />
  //       //     </div>
  //       //   ),
  //       // }));
  //       const data = response.data.map((item, index) => ({
  //         key: item._id,
  //         serial: <div className="text-center">{index + 1}</div>,
  //         formName: <div className="text-center">{item.title}</div>,
  //         assignedOn: <div className="text-center">-</div>,
  //         action: (
  //           <div className="flex justify-center items-center gap-2 sm:gap-3">
  //             <EyeIcon
  //               style={{ fontSize: "16px", cursor: "pointer" }}
  //               className="sm:text-lg"
  //               onClick={() => {
  //                 navigate(`/organization/assigned-form/view/${item._id}`);
  //               }}
  //             />
  //           </div>
  //         ),
  //       }));

  //       setAllData(data);
  //       setFilteredData(data);
  //       setPagination((prev) => ({
  //         ...prev,
  //         total: data.length,
  //       }));
  //     }
  //   } catch (error) {
  //     console.error("Error fetching standard survey forms:", error);
  //   }
  // }, [clientId, projectId, navigate]);

  const fetchTableData = useCallback(async () => {
    try {
      const response = await getApi({
        apiUrl: API_URLS.GET_CUSTOM_FORM_BY_PROJECTID(projectId),
      });
      if (response?.success) {
        const data = response.data.map((item, index) => ({
          key: item._id,
          serial: (
            <div className="text-center" title="">
              {index + 1}
            </div>
          ),
          formName: (
            <div className="text-center" title="">
              {item.title}
            </div>
          ),
          // Add searchable text fields for search functionality
          formNameText: item.title, // Add this for search
          assignedOn: (
            <div className="text-center" title="">
              -
            </div>
          ),
          assignedOnText: "-", // Add this for search
          action: (
            <div
              className="flex justify-center items-center gap-2 sm:gap-3"
              title=""
            >
              <EyeIcon
                style={{ fontSize: "16px", cursor: "pointer" }}
                className="sm:text-lg"
                onClick={() => {
                  navigate(`/organization/assigned-form/view/${item._id}`);
                }}
              />
            </div>
          ),
        }));

        setAllData(data);
        setFilteredData(data);
        setPagination((prev) => ({
          ...prev,
          total: data.length,
        }));
      }
    } catch (error) {
      console.error("Error fetching standard survey forms:", error);
    }
  }, [clientId, projectId, navigate]);

  const handleSearch = (value) => {
    setSearchTerm(value);
    if (value.trim() === "") {
      setFilteredData(allData);
    } else {
      const lower = value.toLowerCase();
      const result = allData.filter(
        (item) =>
          item.formNameText.toLowerCase().includes(lower) ||
          item.assignedOnText.toLowerCase().includes(lower),
      );
      setFilteredData(result);
    }
  };

  useEffect(() => {
    if (!openAddNew && selectedForms.length > 0) {
      addForms({ projectId, selectedForms });
    }
  }, [selectedForms]);

  useEffect(() => {
    if (projectId) {
      fetchTableData();
    }
  }, [projectId, fetchTableData]);

  return (
    <div
      style={{
        border: "1px solid #3BA2B959",
        borderRadius: "10px",
        backgroundColor: "#fff",
      }}
      className="w-full overflow-hidden animate-fadeIn"
    >
      {/* Header Section */}
      <div className="flex flex-col sm:flex-row sm:justify-between mx-4 sm:mx-6 lg:mx-8 my-4 font-medium gap-4 sm:gap-0">
        <div className="flex flex-col sm:flex-row gap-4 sm:gap-8 lg:gap-16">
          <p className="text-[#06513D] pt-2 text-sm sm:text-base font-semibold uppercase">
            Dynamic Survey Form
          </p>
          <div className="w-full sm:w-auto">
            <SearchBar
              width="100%"
              onSearch={handleSearch}
              className="min-w-[200px] sm:min-w-[250px] lg:min-w-[300px]"
            />
          </div>
        </div>
      </div>

      {/* Table & Coming Soon Area */}
      <div className="overflow-x-auto w-full border-t border-[#3BA2B959]">
        <table className="min-w-full text-center border-collapse">
          <thead>
            <tr className="bg-[#FAFBFB] border-b border-gray-100">
              {surveyHeader.map((header) => (
                <th
                  key={header.key}
                  className="py-3 px-4 text-[#06513D] font-normal text-base text-center"
                >
                  {header.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan={surveyHeader.length} className="py-12 px-4">
                <div className="flex flex-col items-center justify-center text-center">
                  <div className="relative mb-6">
                    <div className="absolute inset-0 rounded-full bg-[#06513D]/5 scale-150 animate-ping"></div>
                    <div className="flex items-center justify-center w-20 h-20 sm:w-24 sm:h-24 rounded-full bg-[#E6EEEC] border border-[#06513D]/20">
                      <Sparkles className="w-10 h-10 sm:w-12 sm:h-12 text-[#06513D]" />
                    </div>
                  </div>

                  <h3 className="text-lg sm:text-3xl font-normal text-[#06513D] mb-3">
                    Dynamic Forms Coming Soon
                  </h3>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Modal Components */}
      {openAddNew && (
        <AddNewDynamicForm
          onOpen={openAddNew}
          onClose={() => setOpenAddNew(false)}
          projectId={projectId}
          selectedForms={selectedForms}
          setSelectedForms={setSelectedForms}
          addForms={addForms}
        />
      )}

      {viewForm && (
        <ViewDynamicForm
          viewForm={viewForm}
          onClose={() => setViewForm(false)}
        />
      )}
      {showPopup && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
          <PopupCard
            type={popupData.type}
            title={popupData.title}
            message={popupData.message}
          />
        </div>
      )}
    </div>
  );
};

export default DynamicForm;
